import { none, Option, some, unloadedAsyncState } from "widgets-for-react";
import { linkWrapper } from "../cms/blocks/utils.gen";
import { MediaBlockStyle } from "../cms/blocks/widgets/mediaBlock.gen";
import { TextBlockStyle } from "../cms/blocks/widgets/textBlock.gen";
import { CustomBlock } from "../wordpress/types_and_parser/custom_blocks.mod";
import { PublicSite_CustomPageData } from "./application.mod";
import { CustomBlockData } from "./blocks/custom_blocks/types.mod";
import { mediaBlockClasses, quoteBlockClasses, textBlockClasses } from "./blocks/style.mod";
import { QuoteBlockStyle } from "../cms/blocks/widgets/quoteBlock.gen";



export const CustomBlock_To_Widget = (
  c: CustomBlock,
  block_index: number,
  extra_data: PublicSite_CustomPageData
): Option<CustomBlockData> => {
  if (c.kind == 'vidda/text') {
    const vidda_text: CustomBlockData = {
      kind: 'textBlock',
      value: {
        fst: {
          title: c.attrs.title,
          text: c.attrs.text,
        },
        snd: textBlockClasses as TextBlockStyle
      }
    }

    return some(vidda_text)
  }
  if (c.kind == 'vidda/media') {
    const vidda_media: CustomBlockData = {
      kind: 'mediaBlock',
      value: {
        fst: c.attrs.type == 'image' ? {
          type: 'image',
          useCookieBar: false,
          caption: c.attrs.caption,
          image: c.attrs.image
        } : {
          type: 'video',
          caption: (c.attrs.caption && c.attrs.caption.length != 0) ? c.attrs.caption : null,
          useCookieBar: true,
          video: {
            id: c.attrs.video.id,
            url: c.attrs.video.url,
            type: c.attrs.video.type,
            frameBorder: c.attrs.video.frameBorder,
            allowFullScreen: c.attrs.video.allowFullScreen
          }
        },
        snd: mediaBlockClasses as MediaBlockStyle
      }
    }
    return some(vidda_media)
  }
  if (c.kind == 'vidda/quote') {
    const vidda_quote: CustomBlockData = {
      kind: 'customQuoteBlock',
      value: {
        fst: {
          index: block_index,
          text: c.attrs.text,
        },
        snd: quoteBlockClasses as QuoteBlockStyle
      }
    }
    return some(vidda_quote)
  }
  if (c.kind == 'vidda/header') {
    const vidda_header: CustomBlockData = {
      kind: 'headerBlock',
      value: {
        fst: {
          title: c.attrs.title,
          intro: c.attrs.intro,
          image: c.attrs.image,
          primary_button_text: c.attrs.primary_button_text,
          video_url: c.attrs.video_url,
          video_playing: false,
          block_index: block_index,
          header_kind: c.attrs.header_kind,
          header_type: c.attrs.header_type,
          preview_video: c.attrs.preview_video,
          isInview: false,
        },
        snd: textBlockClasses as QuoteBlockStyle
      }
    }
    return some(vidda_header)
  }
  if (c.kind == 'vidda/image-text') {
    const vidda_image_text: CustomBlockData = {
      kind: 'imageTextBlock',
      value: {
        fst: {
          label: Number(c.attrs.label),
          taxonomy: c.attrs.taxonomy,
          title: c.attrs.title,
          show_primary: c.attrs.show_primary,
          primary_button: linkWrapper({ title: c.attrs.primary_button_text, url: c.attrs.primary_button_url }),
          background_color: c.attrs.background_color,
          images: c.innerBlocks.map(block => block.attrs.image),
          isInView: false,
          block_index: block_index,
        },
        snd: textBlockClasses as QuoteBlockStyle
      }
    }
    return some(vidda_image_text)
  }
  if (c.kind == 'vidda/more-stories') {
    const vidda_more_stories: CustomBlockData = {
      kind: 'moreStoriesBlock',
      value: {
        fst: {
          prev_story: c.attrs.prev_story,
          next_story: c.attrs.next_story,
          show_next: c.attrs.show_next,
          show_prev: c.attrs.show_prev,
          isInview: false,
          block_index: block_index,
          related_stories: unloadedAsyncState()
        },
        snd: {}
      }
    }
    return some(vidda_more_stories)
  }

  return none() // When block is not supported it returns a none
}